<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputAmount" });
import { QUANTITY_RANGES_MIN, QUANTITY_RANGES } from "../../config/quantity-ranges.js";
import { currency } from "../../../../common/format.js";
export let value = void 0;
export let currencyCode = "EUR";
export let quantityCode = void 0;
export let mode = "long";
$: quantityOutput = (mode === "long" ? QUANTITY_RANGES : QUANTITY_RANGES_MIN).find((item) => item.key === quantityCode)?.label ?? "";
</script>

{#if value !== undefined && value > 0}
    { currency(value, currencyCode) }
{:else if quantityCode !== undefined && quantityOutput !== ''}
    { `${ quantityOutput } ${ mode === 'short' ? 'Items' : '' }` }
{:else}
    -
{/if}